module.exports = __webpack_public_path__ + "img/1001.b5d1a155.svg";